<template>
    <div class="NodeEditor LinkScenarioNodeEditor">
        <NodeSaveStatus></NodeSaveStatus>
        <NodeHeaderEditor
            key="NodeHeaderEditor"
            :name.sync="node.name"
            :id="node.id"
            :slug="node.slug"
            :type="node.type"
            ref="NodeHeaderEditor"
            @save="saveNode"
            @delete="deleteNode"
            @close="closePanelRight"
        ></NodeHeaderEditor>
        <div class="scroll-container fci-scrollbar">
            <ScenarioCard :name="this.$filters.capitalize($t('scenario'))">
                <v-layout>
                    <div>
                        {{ this.$filters.capitalize($t('linkToScenario')) }}:<br>
                        <span v-if="canAccessScenario" class="scenario-name">
                            {{ scenario.name }}
                        </span>
                        <div v-else>
                            <div class="scenario-id">{{ node.config.scenario_id }}</div>
                            <div class="text-permission mt-6 display-flex align-center">
                                <v-icon color="#856404" size="19" class="mr-6">mdi-alert-circle</v-icon>
                                {{ $f.tc('youDoesNotHavePermissionToViewThisBot') }}!
                            </div>
                        </div>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="btn-icon-2 btn-link" @click="goToScenario" v-if="canAccessScenario">
                        <img src="/img/scenario/arrow-right.svg" alt="icon-link" style="transform: scale(1.15)">
                    </div>
                </v-layout>
                <template v-if="ScenarioService.isEditable()">
                    <div class="mt-12">
                        <v-text-field
                            hide-details outlined
                            v-model="searchKey"
                            :placeholder="$f.tc('searchScenario')"
                            class="input-custom"
                        ></v-text-field>
                    </div>
                    <v-layout
                        align-center
                        v-for="item in scenarioList"
                        :key="item.id"
                        @click="selectScenario(item)"
                        class="item-container mt-8"
                    >
                        {{ item.name }}
                    </v-layout>
                </template>
            </ScenarioCard>
        </div>
    </div>
</template>

<script>
import NodeEditor from '@/views/Scenario/NodeEditor/NodeEditor'
import NodeSaveStatus from '@/views/Scenario/NodeEditor/NodeSaveStatus'
import NodeHeaderEditor from '@/views/Scenario/NodeEditor/common/NodeHeaderEditor'
import ScenarioService from '@/services/scenario.service'
import ScenarioCard from '@/views/Scenario/components/ScenarioCard'

export default {
    name: 'LinkScenarioNodeEditor',
    components: {ScenarioCard, NodeHeaderEditor, NodeSaveStatus},
    extends: NodeEditor,
    data() {
        return {
            ScenarioService,
            searchKey: '',
            scenario: {},
            scenarioList: [],
            canAccessScenario: true
        }
    },
    mounted() {
        ScenarioService.CRUD.read(this.node.config.scenario_id).then(result => {
            this.scenario = result.data
        }, error => {
            if (error.response && error.response.status === 404) {
                this.canAccessScenario = false
            }
        })
    },
    methods: {
        searchScenario() {
            ScenarioService.CRUD.search({search: this.searchKey, page: 1, page_size: 5}).then(result => {
                this.scenarioList = result.data.data
                // filter out editing scenario
                // this.scenarioList = this.scenarioList.filter(
                //     scenario => scenario.id !== this.$route.params.scenarioId
                // )
            })
        },
        selectScenario(scenario) {
            this.node.config.scenario_id = scenario.id
            this.scenario = scenario
            this.canAccessScenario = true
            this.saveNode()
        },
        goToScenario() {
            window.open(this.$router.resolve(`/scenarios/${this.scenario.id}`).href, '_blank')
        },
        getConfig() {
            return {
                name: this.node.name,
                config: {
                    scenario_id: this.scenario.id,
                    node_id: ''
                }
            }
        }
    },
    watch: {
        searchKey: 'searchScenario'
    }
}
</script>

<style scoped lang="scss">
@import "NodeEditor.scss";

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }
}

.item-container {
    padding: 10px;
    cursor: pointer;
    height: 48px;
    padding: 0 12px;
    border-radius: 5px;

    &:hover {
        background: #F2F2F2;
    }
}

.scenario-name {
    font-size: 22px;
    font-weight: bold;
}

.scenario-id {
    font-weight: bold;
}

.btn-link {
    background: #F2F2F2 !important;
}

.text-permission {
    font-family: 'open sans';
    font-size: 14px;
    background: #ffeeba;
    color: #856404;
    padding: 0 12px;
    height: 32px;
    line-height: 32px;
    border-radius: 5px;
}
</style>
